import { Container, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list";
import * as tags from "@repoflow/form-schema/widgets/tag";
import * as KeyQL from "queries/domain-key";
import * as KeyAccess from "components/key-access";
import * as Section from "@repoflow/components/section";

export const Sidebar = () => null;

// The section that owns this page draws the "API Keys" crumb, so there is
// nothing left for the list itself to add.
export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base, schema } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add API Key
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.domains.get.keys"}
        query={KeyQL.list}
        variables={params}
        schema={schema}
        target={{ $ref: "/Public/Key" }}
        empty={"No API keys yet."}
        widgets={{ tags, ...KeyAccess.widgets }}
        config={{
          "/Public/Key": {
            fields: [KeyAccess.keyIdColumn, "roles", "createdAt"],
          },
        }}
        content={({ item: { keyId } }) => (
          <Link className={"btn btn-primary"} to={`${base}/${keyId}`}>
            View
          </Link>
        )}
      />
    </Container>
  );
};
